const apiMap = {
  api: process.env.REACT_APP_WEB_API_BASE_URL,
  xspocapi: process.env.REACT_APP_XSPOC_API_BASE_URL,
};

export const getAPIBaseURL = (id = "api") => {

  const lowercasedId = id.toLowerCase();
  const baseUrl = apiMap[lowercasedId];

  if (baseUrl) {
    return `${lowercasedId}`;
  }
 
  return `${lowercasedId}`;
};
 
export const getXSPOCAPIBaseURL = (id = "xspocapi") => {
  const lowercasedId = id.toLowerCase();
  const baseUrl = apiMap[lowercasedId];
 
  if (baseUrl) {
    return `api`;
  }
 
  return `${lowercasedId}`;
};

export const getAllyConnectURL = (loginURL: string | null): string => {
  if (!loginURL) {
    throw new Error('Login URL is not available');
  }
  return loginURL;
};
